export default __webpack_public_path__ + "static/media/hariabhijit.0e8c64a9.jpg";